import styled, { css } from 'styled-components'
import { BulkOrderSectionLabel } from './bulkOrderSectionLabel.styles'
import {
  SCROLL_FADE_HEIGHT_CATALOG,
  scrollFadeDarkDown,
  scrollFadeDarkUp,
} from './bulkOrderScrollFade.styles'

const scrollFadeHeight = SCROLL_FADE_HEIGHT_CATALOG

export const Sidebar = styled.aside`
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  width: 100%;
  overflow: hidden;
  background-color: ${({ theme }) => theme.colors.lensSelectCatalogBackground};
  border-right: 1px solid ${({ theme }) => theme.colors.gray3};
`

export const SidebarHeader = styled.div`
  flex-shrink: 0;
  padding: 1.2rem;
  border-bottom: 1px solid ${({ theme }) => theme.colors.gray3};
`

export const FilterSection = styled.div`
  flex-shrink: 0;
  padding: 1rem 1.2rem;
  border-bottom: 1px solid ${({ theme }) => theme.colors.gray3};

  &:last-of-type {
    border-bottom: none;
  }
`

export const FilterLabel = BulkOrderSectionLabel

export const FilterPills = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.6rem;
`

export const FilterPill = styled.button`
  ${({ $isActive, theme: { button } }) => css`
    border: 1px solid ${button.borderColor};
    border-radius: 999px;
    padding: 0.25rem 0.9rem;
    font-size: 1.2rem;
    line-height: 1.4;
    font-weight: 400;
    cursor: pointer;
    background: ${button.backgroundColor};
    color: ${button.textColor};
    white-space: nowrap;

    ${$isActive &&
    css`
      background: ${button.activeBackgroundColor};
      border-color: ${button.borderColor};
      color: ${button.activeTextColor};
    `}

    &:hover {
      ${$isActive
        ? css`
            background: ${button.activeBackgroundColor};
            border-color: ${button.borderColor};
            color: ${button.activeTextColor};
          `
        : css`
            background: ${button.hoverBackgroundColor};
            border-color: ${button.hoverBorderColor};
            color: ${button.hoverTextColor};
          `}
    }
  `}
`

export const CatalogListViewport = styled.div`
  flex: 1;
  min-height: 0;
`

export const GroupHeader = styled.button`
  ${({ $isExpanded, theme }) => css`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 0.8rem;
    width: 100%;
    padding: 0.9rem 1.2rem;
    border: none;
    border-bottom: 1px solid ${theme.colors.gray3};
    background: ${theme.colors.lensSelectCatalogBackground};
    position: sticky;
    top: 0;
    z-index: 1;
    transform: translateZ(0);
    cursor: pointer;
    text-align: left;
    font-size: 1.2rem;
    font-weight: 700;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: ${theme.colors.text2};
    transition: color 0.15s ease;

    &:hover {
      color: #000;
    }

    ${$isExpanded &&
    css`
      overflow: visible;

      &::after {
        content: '';
        position: absolute;
        left: 0;
        right: 0;
        bottom: -${scrollFadeHeight};
        height: ${scrollFadeHeight};
        z-index: 1;
        pointer-events: none;
        ${scrollFadeDarkDown}
      }
    `}

    &:focus {
      outline: none;
    }
  `}
`

export const ProductGroup = styled.div`
  position: relative;

  &::after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: ${scrollFadeHeight};
    z-index: 1;
    pointer-events: none;
    ${scrollFadeDarkUp}
  }
`

export const GroupHeaderLabel = styled.span`
  display: flex;
  align-items: baseline;
  gap: 0.5rem;
  flex: 1;
  min-width: 0;
  color: inherit;
  transition: color 0.15s ease;
`

export const GroupHeaderCount = styled.span`
  font-weight: 600;
  color: ${({ theme }) => theme.colors.text3};
`

export const GroupChevron = styled.span`
  ${({ $isExpanded, theme }) => css`
    display: inline-flex;
    flex-shrink: 0;
    transition: transform 0.15s ease, color 0.15s ease;
    transform: rotate(${$isExpanded ? '180deg' : '0deg'});
    color: ${theme.colors.text3};

    ${GroupHeader}:hover & {
      color: #000;
    }
  `}
`

export const ProductName = styled.span`
  ${({ theme, $isSelected }) => css`
    flex: 1;
    min-width: 0;
    font-size: 1.3rem;
    color: ${$isSelected ? theme.button.activeTextColor : theme.colors.text};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  `}
`

export const CoatingBadge = styled.span`
  ${({ theme, $isSelected }) => css`
    flex-shrink: 0;
    border-radius: 999px;
    padding: 0.1rem 0.45rem;
    font-size: 1rem;
    font-weight: 600;
    line-height: 1.3;
    background: ${$isSelected ? 'rgba(255, 255, 255, 0.15)' : theme.colors.gray};
    color: ${$isSelected ? theme.button.activeTextColor : theme.colors.text2};
  `}
`

export const ProductRow = styled.button`
  ${({ $isSelected, theme }) => css`
    display: flex;
    align-items: center;
    gap: 0.8rem;
    width: 100%;
    padding: 1rem 1.2rem;
    border: none;
    border-bottom: 1px solid ${theme.colors.gray3};
    background: white;
    cursor: pointer;
    text-align: left;
    transition: background-color 0.15s ease, color 0.15s ease;

    ${$isSelected &&
    css`
      background: ${theme.button.activeBackgroundColor};
    `}

    &:hover {
      background: ${$isSelected ? theme.button.activeBackgroundColor : '#F7F7F7'};
    }
  `}
`

export const EmptyState = styled.div`
  padding: 2rem 1.2rem;
  text-align: center;
  font-size: 1.3rem;
  color: ${({ theme }) => theme.colors.text3};
`
